<div *ngIf="emulatedUser()" class="cm__emulating-message" role="alert">
  <div class="cm__emulating-message__wrap">
    <div class="cm__emulating-message__text">
      <strong> Currently emulating user: </strong> {{ emulatedUser()?.name }}
    </div>
    <div class="cm__emulating-message__action">
      <a href="/internal-tools/emulate-user" class="cm__button cm__button--tertiary">Stop emulating</a>
    </div>
  </div>
</div>
